import type { MouseEventHandler } from 'react';
import { useState } from 'react';
import classNames from 'classnames';

import { IconDarkColor } from '@trello/nachos/icon';
import { EditIcon } from '@trello/nachos/icons/edit';
import { token } from '@trello/theme';

import styles from './DeprecatedEditCardButton.less';

interface DeprecatedEditCardButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  shouldShow: boolean;
}

/**
 * DEPRECATED - This was used to render the edit button for non-standard card
 * types in a non-React context. In our Board Canvas Modernization rewrite,
 * this logic will be contained within the CardFront component directly.
 * @deprecated
 */
export const DeprecatedEditCardButton = ({
  onClick,
  shouldShow,
}: DeprecatedEditCardButtonProps) => (
  <button
    className={classNames(styles.editCardButton, shouldShow && styles.show)}
    onClick={onClick}
  >
    <EditIcon
      color={token('color.text.accent.gray.bolder', IconDarkColor)}
      size="small"
    />
  </button>
);

/** @deprecated */
export const useDeprecatedEditCardButton = () => {
  const [shouldShowEditCardButton, setShouldShowEditCardButton] =
    useState(false);

  const showEditCardButton = () => setShouldShowEditCardButton(true);
  const hideEditCardButton = () => setShouldShowEditCardButton(false);

  return {
    showEditCardButton,
    hideEditCardButton,
    shouldShowEditCardButton,
  };
};
